module.exports = __webpack_public_path__ + "static/media/Asset 8.1@3x.40b02698.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 8.1@3x.png
// module id = 2401
// module chunks = 0